/* eslint-disable @next/next/no-img-element */
import { useState, useEffect, useRef } from "react";
import { useRouter } from "next/router";
import { HiOutlineChevronUp, HiOutlineChevronDown } from "react-icons/hi";
import { RiNumber1, RiNumber2, RiNumber3 } from "react-icons/ri";
import { TfiClose } from "react-icons/tfi";
import { usePathname } from "next/navigation";
import { PLPModalImageFormatter } from "@/components/ProductListing/helper";
// import { staticLabelsCompare } from "../CompareSection/helper";
import { DEFAULT_IMAGE_LINK } from "@/components/detailsComponent/helper";
import { useContentfulTranslations } from "@/utils/contentfulTranslations";

{
  /* TODO: Label from CTFL */
}
const CompareProducts = ({
  navbarOpen = false,
  compareData,
  headerLabelKitchen,
  headerlabelBathroom,
  isStorage,
  // modalOpen = true,
  // setModalOpen,
}) => {
  const pathname = usePathname();
  const [open, setOpen] = useState(true);
  const [storage, setStorage] = useState(() => {
    if (typeof window !== "undefined") {
      const stored = localStorage.getItem("compareProducts");
      return stored ? JSON.parse(stored) : [];
    }
    return [];
  });
  const [modalOpen, setModalOpen] = useState(() => {
    if (typeof window !== "undefined") {
      const stored = localStorage.getItem("compareProducts");
      return navbarOpen || (stored ? JSON.parse(stored).length > 0 : false);
    }
    return navbarOpen;
  });
  const [headerBottom, setHeaderBottom] = useState(112);
  const [headerTranslated, setHeaderTranslated] = useState(false);
  const compareBarRef = useRef(null);

  const shouldShowModal = storage.length > 0;
  //   const [productDetails, setProductDetails] = useState([])
  const router = useRouter();
  const { locale: routerLocale } = router;
  const locale =
    routerLocale === "default"
      ? process.env.NEXT_PUBLIC_DEFAULT_LOCALE
      : routerLocale;

  const { staticLabelsCompare } = useContentfulTranslations();

  useEffect(() => {
    const isDesktop = () => window.innerWidth > 1023;
    const updateTop = () => {
      if (isDesktop()) {
        setHeaderBottom(window.scrollY > 50 ? 80 : 112);
      } else {
        setHeaderBottom(60);
      }
    };
    updateTop();
    window.addEventListener("scroll", updateTop);
    window.addEventListener("resize", updateTop);
    return () => {
      window.removeEventListener("scroll", updateTop);
      window.removeEventListener("resize", updateTop);
    };
  }, []);

  useEffect(() => {
    const onHeaderVisible = e => {
      setHeaderTranslated(e.detail?.visible ?? false);
    };
    globalThis.addEventListener("kohler-header-visible", onHeaderVisible);
    return () => {
      globalThis.removeEventListener("kohler-header-visible", onHeaderVisible);
    };
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined") {
      localStorage.setItem("compareProducts", JSON.stringify(storage));
      setOpen(true);
    }
  }, [storage]);

  useEffect(() => {
    const syncStorage = () => {
      const updated = JSON.parse(localStorage.getItem("compareProducts")) || [];
      setStorage(updated);
      if (updated.length > 0) {
        setModalOpen(true);
      }
    };

    window.addEventListener("storage", syncStorage);

    return () => {
      window.removeEventListener("storage", syncStorage);
    };
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  // Push the PDP page content down by the compare bar's current height so
  // breadcrumbs and other page content are not hidden behind it. When the bar
  // is collapsed (chevron-up) the page shifts back to the collapsed height,
  // and when expanded (chevron-down) it shifts down by the full expanded
  // height.
  useEffect(() => {
    if (typeof globalThis.window === "undefined") return undefined;
    if (!modalOpen || !shouldShowModal) return undefined;

    const target = document.querySelector("main") || document.body;
    if (!target) return undefined;

    const previousPaddingTop = target.style.paddingTop;
    const previousTransition = target.style.transition;
    target.style.transition = "padding-top 0.2s ease";

    const applyOffset = () => {
      const barEl = compareBarRef.current;
      if (!barEl) return;
      const barHeight = barEl.getBoundingClientRect().height;
      target.style.paddingTop = `${Math.ceil(barHeight)}px`;
    };

    applyOffset();

    let resizeObserver;
    if (typeof ResizeObserver !== "undefined" && compareBarRef.current) {
      resizeObserver = new ResizeObserver(applyOffset);
      resizeObserver.observe(compareBarRef.current);
    }
    window.addEventListener("resize", applyOffset);

    return () => {
      if (resizeObserver) resizeObserver.disconnect();
      window.removeEventListener("resize", applyOffset);
      target.style.paddingTop = previousPaddingTop;
      target.style.transition = previousTransition;
    };
  }, [modalOpen, shouldShowModal, open, headerBottom]);

  const removeFromCompare = (e, id) => {
    e.preventDefault();
    const localStorageCheck =
      JSON.parse(localStorage.getItem("compareProducts")) || [];
    if (localStorageCheck !== null) {
      const filteredArr = localStorageCheck.filter(function (el) {
        return el?.compareMappedValues?.skuId !== id;
      });
      localStorage.setItem("compareProducts", JSON.stringify(filteredArr));
      setStorage(filteredArr);
    }
    window.dispatchEvent(new Event("storage"));
  };

  const handleClear = () => {
    localStorage.removeItem("compareProducts");
    setStorage([]);
    window.dispatchEvent(new Event("storage"));
  };

  if (!shouldShowModal) return null;

  return (
    <>
      {modalOpen && (
        <div
          ref={compareBarRef}
          className="fixed left-0 w-full z-50 flex items-start justify-center max-md:hidden"
          style={{
            top:
              headerBottom +
              (headerTranslated && headerBottom !== 112 ? 32 : 0),
          }}
        >
          <div className="bg-white w-full border-t border-[#e5e5e5] shadow-[0_8px_16px_-2px_rgba(0,0,0,0.45)] justify-center items-center">
            <div className="p-[10px] max-w-screen-lg mx-auto">
              <div className="flex justify-between mb-2">
                <div className="text-[#232323] font-[Helvetica-Light,_Helvetica,_sans-serif] block float-left ml-[10px] text-[18px] leading-[51px] uppercase">
                  {staticLabelsCompare?.[locale]?.compareProducts ||
                    staticLabelsCompare?.["en"]?.compareProducts}
                </div>
                <div className="flex items-center">
                  <div className="flex mr-3">
                    <button
                      type="button"
                      className="cursor-pointer float-right h-[51px] text-[14px] leading-[47px] underline bg-transparent border-0 outline-none cursor-pointer text-[#232323] font-[HelveticaRoman,Helvetica,sans-serif] pt-1"
                      onClick={handleClear}
                    >
                      {staticLabelsCompare?.[locale]?.clearResults ||
                        staticLabelsCompare?.["en"]?.clearResults}
                    </button>
                  </div>
                  <div className="flex mr-3">
                    <button
                      type="button"
                      onClick={e => {
                        e.preventDefault();
                        router.push("/compare");
                      }}
                      className="cursor-pointer bg-[#e5e5e5] text-[#232323] inline-block py-[13.5px] px-[20px] border-0 rounded-[4px] font-[HelveticaBold,Helvetica,sans-serif] text-[13px] leading-[1em] float-right mt-[4px] mr-[10px] mb-[0] ml-[15px] shadow-[0_2px_2px_0_rgba(0,0,0,0.2)] font-normal text-center uppercase no-underline outline-none hover:bg-[#bebebe]"
                    >
                      {staticLabelsCompare?.[locale]?.compare ||
                        staticLabelsCompare?.["en"]?.compare}
                    </button>
                  </div>
                  <div className="flex mr-3 cursor-pointer">
                    <button
                      type="button"
                      className="cursor-pointer"
                      onClick={() => setOpen(!open)}
                    >
                      {open ? (
                        <HiOutlineChevronUp size={25} />
                      ) : (
                        <HiOutlineChevronDown size={25} />
                      )}
                    </button>
                  </div>
                </div>
              </div>
              {open ? (
                <div
                  className={`text block flex justify-between border-t border-[#e5e5e5] py-[25px] w-full h-[230px]`}
                >
                  {storage && storage[0] ? (
                    <div className="flex grow w-1/3 px-[10px] flex-col">
                      <button
                        type="button"
                        className="flex justify-end cursor-pointer"
                        onClick={e =>
                          removeFromCompare(
                            e,
                            storage[0]?.compareMappedValues?.skuId
                          )
                        }
                      >
                        <TfiClose size={15} color="#999" />
                      </button>
                      <img
                        src={PLPModalImageFormatter(
                          storage[0]?.image[0] ||
                            storage[0]?.compareMappedValues?.image?.[0]
                        )}
                        alt={storage[0]?.compareMappedValues?.["Brand Name"]}
                        style={{ height: "51px", width: "68px" }}
                        onError={e =>
                          (e.target.src =
                            storage[0]?.fallbackImage || DEFAULT_IMAGE_LINK)
                        }
                      />
                      {/* PDP product link */}
                      <a
                        href={`/${locale}/product-details/${storage[0]?.compareMappedValues?.slug}?sku=${storage[0]?.swatch[0]?.skuid || storage[0]?.compareMappedValues?.skuId}`}
                        className="hover:!no-underline"
                      >
                        <p className="text-[#999] font-helveticaGroup text-[16px] leading-normal font-bold">
                          {storage[0]?.compareMappedValues?.["Brand Name"]}
                        </p>
                        <p className="text-[#232323] font-[helveticaBold,_Helvetica,_sans-serif] text-[16px] leading-normal">
                          {storage[0]?.compareMappedValues?.["Description"]}
                        </p>
                        <p className="text-[#999] pt-[15px] font-helveticaGroup text-[16px] leading-normal font-light">
                          K-{storage[0]?.compareMappedValues?.skuId}
                        </p>
                        {storage[0]?.compareMappedValues?.price &&
                          Number(storage[0]?.compareMappedValues?.price) !==
                            0 && (
                            <p className="text-[#232323] font-helveticaBold text-[16px] leading-normal font-[600]">
                              {storage[0]?.compareMappedValues?.price}
                            </p>
                          )}
                      </a>
                    </div>
                  ) : (
                    <div className="flex grow w-1/3 justify-center px-2.5 items-center">
                      <RiNumber1 className="block w-full leading-[150px] font-[HelveticaLight,Helvetica,sans-serif] text-[80px] text-center text-[#bebebe]" />
                    </div>
                  )}
                  {storage && storage[1] ? (
                    <div className="flex grow w-1/3 px-[10px] flex-col border-x border-[#e5e5e5]">
                      <button
                        type="button"
                        className="flex justify-end cursor-pointer"
                        onClick={e =>
                          removeFromCompare(
                            e,
                            storage[1]?.compareMappedValues?.skuId
                          )
                        }
                      >
                        <TfiClose size={15} color="#999" />
                      </button>
                      <img
                        src={PLPModalImageFormatter(
                          storage[1]?.image[0] ||
                            storage[1]?.compareMappedValues?.image?.[0]
                        )}
                        alt={storage[1]?.compareMappedValues?.["Brand Name"]}
                        style={{ height: "51px", width: "68px" }}
                        onError={e =>
                          (e.target.src =
                            storage[1]?.fallbackImage || DEFAULT_IMAGE_LINK)
                        }
                      />
                      {/* PDP product link */}
                      <a
                        href={`/${locale}/product-details/${storage[1]?.slug}?sku=${storage[1]?.swatch[0]?.skuid || storage[1]?.compareMappedValues?.skuId}`}
                        className="hover:!no-underline"
                      >
                        <p className="text-[#999] font-helveticaGroup text-[16px] leading-normal font-bold">
                          {storage[1]?.compareMappedValues?.["Brand Name"]}
                        </p>
                        <p className="text-[#232323] font-[helveticaBold,_Helvetica,_sans-serif] text-[16px] leading-normal">
                          {storage[1]?.compareMappedValues?.["Description"]}
                        </p>
                        <p className="text-[#999] pt-[15px] font-helveticaGroup text-[16px] leading-normal font-light">
                          K-{storage[1]?.compareMappedValues?.skuId}
                        </p>
                        {storage[1]?.compareMappedValues?.price &&
                          Number(storage[1]?.compareMappedValues?.price) !==
                            0 && (
                            <p className="text-[#232323] font-helveticaBold text-[16px] leading-normal font-[600]">
                              {storage[1]?.compareMappedValues?.price}
                            </p>
                          )}
                      </a>
                    </div>
                  ) : (
                    <div className="flex grow w-1/3 justify-center border-x border-[#e5e5e5]  px-2.5 items-center">
                      <RiNumber2 className="block w-full leading-[150px] font-[HelveticaLight,Helvetica,sans-serif] text-[80px] text-center text-[#bebebe]" />
                    </div>
                  )}
                  {storage && storage[2] ? (
                    <div className="flex grow w-1/3 px-[10px] flex-col">
                      <button
                        type="button"
                        className="flex justify-end cursor-pointer"
                        onClick={e =>
                          removeFromCompare(
                            e,
                            storage[2]?.compareMappedValues?.skuId
                          )
                        }
                      >
                        <TfiClose size={15} color="#999" />
                      </button>
                      <img
                        src={PLPModalImageFormatter(
                          storage[2]?.image[0] ||
                            storage[2]?.compareMappedValues?.image?.[0]
                        )}
                        alt={storage[2]?.compareMappedValues?.["Brand Name"]}
                        style={{ height: "51px", width: "68px" }}
                        onError={e =>
                          (e.target.src =
                            storage[2]?.fallbackImage || DEFAULT_IMAGE_LINK)
                        }
                      />
                      {/* PDP product link */}
                      <a
                        href={`/${locale}/product-details/${storage[2]?.slug}?sku=${storage[2]?.swatch[0]?.skuid || storage[2]?.compareMappedValues?.skuId}`}
                        className="hover:!no-underline"
                        target="_self"
                      >
                        <p className="text-[#999] font-helveticaGroup text-[16px] leading-normal font-bold">
                          {storage[2]?.compareMappedValues?.["Brand Name"]}
                        </p>
                        <p className="text-[#232323] font-[helveticaBold,_Helvetica,_sans-serif] text-[16px] leading-normal">
                          {storage[2]?.compareMappedValues?.["Description"]}
                        </p>
                        <p className="text-[#999] pt-[15px] font-helveticaGroup text-[16px] leading-normal font-light">
                          K-{storage[2]?.compareMappedValues?.skuId}
                        </p>
                        {storage[2]?.compareMappedValues?.price &&
                          Number(storage[2]?.compareMappedValues?.price) !==
                            0 && (
                            <p className="text-[#232323] font-helveticaBold text-[16px] leading-normal font-[600]">
                              {storage[2]?.compareMappedValues?.price}
                            </p>
                          )}
                      </a>
                    </div>
                  ) : (
                    <div className="flex grow w-1/3 justify-center  px-2.5 items-center">
                      <RiNumber3 className="block w-full leading-[150px] font-[HelveticaLight,Helvetica,sans-serif] text-[80px] text-center text-[#bebebe]" />
                    </div>
                  )}
                </div>
              ) : null}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CompareProducts;
